<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card">
	<div class="card-header bg-theme mb-0">
		<h5 class="card-title text-light mb-0">
			{{pagetitle}}
		</h5>
	</div>
	<div class="card-body py-0 px-1">
		@if(navbar.hasRegularizationAccess()){
		<div class="table-responsive">
			<table *ngIf="dtOptions.pagingType" datatable [dtOptions]="dtOptions"
				class="table table-bordered table-hover">
				<thead>
					<tr class="table_head">
						<th style="width: 30% !important;">Employee</th>
						<th style="width: 10% !important;">Date</th>
						<th style="width: 15% !important;">In</th>
						<th style="width: 15% !important;">Out</th>
						<th style="width: 10% !important;">Duration(HH:mm)</th>
						<th style="width: 10% !important;">Approval</th>
						<th style="width: 10% !important;">Action</th>
					</tr>
				</thead>
				<tbody *ngIf="dataList?.length !== 0">
					<tr *ngFor="let v of dataList;let i = index;">
						<td>
							{{ v.emp_code?.first_name }} {{ v.emp_code?.last_name }}
						</td>
						<td>{{ v.date }}</td>
						<td>{{ v.in_date }} {{ v.in_time }}</td>
						<td>{{ v.out_date }} {{ v.out_time }}</td>
						<td>{{ v.work_time }}</td>
						<td>
							@if (v.is_approved) {
							<span class="badge bg-success text-light">
								Approved
							</span>
							}@else if(navbar.hasRegularizationAccess()) {
							<button class="btn btn-xs btn-warning" matTooltip="Approve" (click)="approveRequest(v.id)">
								<fa-icon *ngIf="showApproveLoader !== v.id" [icon]="['fas', 'check']"></fa-icon>
								<fa-icon *ngIf="showApproveLoader === v.id" [icon]="['fas', 'spinner']"
									animation="spin"></fa-icon>
								Approve
							</button>
							}
						</td>
						<td>
							@if (
							navbar.hasRegularizationAccess() ||
							v.emp_code?.emp_code == navbar.user?.emp_code
							) {
							<button class="btn btn-xs btn-primary ms-1" matTooltip="Edit" (click)="createEditReg(v)">
								<fa-icon [icon]="['fas', 'edit']"></fa-icon>
							</button>
							<button class="btn btn-xs btn-danger ms-1" matTooltip="Delete"
								(click)="deleteConfirm(v.id)">
								<fa-icon *ngIf="showDeleteLoader !== v.id" [icon]="['fas', 'times']"></fa-icon>
								<fa-icon *ngIf="showDeleteLoader === v.id" [icon]="['fas', 'spinner']"
									animation="spin"></fa-icon>
							</button>
							}
						</td>
					</tr>
				</tbody>
				<tbody *ngIf="dataList?.length === 0">
					<tr>
						<td colspan="7" class="text-center">No data found!</td>
					</tr>
				</tbody>
			</table>
		</div>
		}@else {
		<h3 class="text-center">You don't have access to this section.</h3>
		}
	</div>
</div>
<app-regularization-form [userList]="userList" (created)="refreshTable()">
</app-regularization-form>